import cx from 'classnames';
import s from './styles.scss';
import { enums } from 'edrolo-ui';

export interface AlertProps {
  children: React.ReactNode;
  className?: string;
  color?:
    | enums.ColorHue.GREEN
    | enums.ColorHue.BLUE
    | enums.ColorHue.YELLOW
    | enums.ColorHue.RED
    | enums.ColorHue.GREY;
}

export const Alert = ({
  className,
  children,
  color = enums.ColorHue.RED,
}: AlertProps) => {
  return <div className={cx(s.alert, className, s[color])}>{children}</div>;
};
